<template>
  <div id="modify">
    <!-- 导航栏 -->
    <navMenu positionType="fixed" topValue="0"></navMenu>
    <!-- banner -->
    <banner title="关于改图" desc="我们不一样" marginTop="66px"></banner>
    <div class="container bgwhite">
      <div class="layout main">
        <div class="title">
          <p>改图规则和收费</p>
        </div>
        <div class="text flex-center">
          <!-- v1.0 -->
          <!-- <div class="wrap">
            <div class="first">
              <div class="heading">
                <p>一、首次免费调整部分（普通效果图）</p>
              </div>
              <div class="consists">
                <p>1、简单的材质变化和改个沙发等简单配饰等可以不收费，首次免费修改一次；</p>
                <p>2、ps的后期处理；</p>
                <p>3、客户保障中的质量问题：大图模型悬浮、重叠、破面；贴图丢失、断裂、纹理大小不一（如客户保障中质量 问题项目增加，则增加项目也将免费）；</p>
              </div>
            </div>
            <div class="first">
              <div class="heading">
                <p>二、首次调整收费（360全景效果图）</p>
              </div>
              <div class="consists">
                <p>1、ps的后期处理免费调整；；</p>
                <p>2、首次需云渲染的简单修改（如：改个沙发等简单配饰），仅收取云渲染费30元；</p>
              </div>
            </div>
            <div class="first">
              <div class="heading">
                <p>三、修改付费部分：</p>
              </div>
              <div class="consists">
                <p>1、改图费用为原设计助理时价*10小时的10%~100%（风格变动—平面布局更改，根据实际情况而定），修改费60元/张起步；</p>
                <p>2、角度变换（原则上，模型无需加建的可以免费“360全景除外”，其他的需要根据实际情况收取10%-80%费用）；</p>
                <p>3、灯光氛围及色调大幅度修改，如：白天改晚上等（20%-80%）；</p>
                <p>4、如改顶面或者背景墙地面拼花等造型，收取原价的（20%-80%）;</p>
                <p>5、完成改图后，改动方案又超过50％的或换风格的，按新图标准收费；</p>
                <p>6、超过原上门做图价，建议重新下单该上门设计助理上门修改。</p>
              </div>
            </div>
          </div> -->
          <!-- v2.0 -->
          <div class="wrap">
            <div class="first">
              <div class="heading">
                <p>改图方式一：</p>
              </div>
              <div class="consists">
                <p>总部远程改图，45元/小时</p>
              </div>
            </div>
            <div class="first">
              <div class="heading">
                <p>改图方式二：</p>
              </div>
              <div class="consists">
                <p>上门改图，按上门人员标价收取</p></div>
            </div>
            <div class="first">
              <div class="heading">
                <p>建议：修改不多，远程改图，经济实惠</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部导航栏 -->
    <bottom></bottom>
    <!-- 二维码 -->
    <qrcode></qrcode>
  </div>
</template>

<script>
import navMenu from "@/components/navMenu";
import banner from "@/components/banner";
import bottom from "@/components/footer";
import qrcode from "@/components/qrcode";
export default {
  components: {
    navMenu,
    banner,
    bottom,
    qrcode
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
#modify {
  .container {
    margin-bottom: 24px;
    .layout {
      padding-top: 76px;
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #212240;
        text-align: center;
      }
      .text {
        padding-top: 46px;
        .wrap {
          .first {
            margin-bottom: 33px;
            &:last-child {
              margin-bottom: 0;
              padding-bottom: 83px;
            }
            .heading {
              font-size: 14px;
              font-weight: 500;
              color: #212240;
            }
            .consists {
              border-left: 4px solid #f5f5f7;
              padding-left: 27px;
              margin-top: 12px;
              p {
                width: 780px;
                font-size: 14px;
                font-weight: 500;
                color: #898a9b;
                margin-bottom: 12px;
                &:last-child {
                  margin-bottom: 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
